import { createAction } from '../../../store.model';
import { ActionType } from '../main.action';

export interface SelectTemplateVersion {
    templateVersionId?: number;
}

export const selectTemplateVersion = createAction<
    ActionType,
    SelectTemplateVersion
>(ActionType.EVAL_MAIN__SELECT_TEMPLATE_VERSION);
